var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.625,
    height: 40.27,
    viewBox: "0 0 65.625 40.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people",
    transform: "translate(-2 -11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M16.4,16a9.4,9.4,0,1,0,9.4,9.4A9.4,9.4,0,0,0,16.4,16Z",
    transform: "translate(4.396 1.317)",
    fill: "#fae8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    d: "M2,40.239S6.176,28.4,16.915,28.4,31.83,40.239,31.83,40.239v6.2H2Zm65.625,0S63.449,28.4,52.71,28.4,37.8,40.239,37.8,40.239v6.2h29.83Z",
    transform: "translate(0 4.83)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    "data-name": "Path 3979",
    d: "M29.275,11A11.275,11.275,0,1,0,40.55,22.275,11.275,11.275,0,0,0,29.275,11Z",
    transform: "translate(5.537)",
    fill: "#5d4522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M40.042,40.694S36.186,26.6,26.021,26.6,12,40.694,12,40.694v7.329H40.042Z",
    transform: "translate(8.792 3.247)",
    fill: "#607d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M40.4,16a9.4,9.4,0,1,0,9.4,9.4A9.4,9.4,0,0,0,40.4,16Z",
    transform: "translate(8.437 1.317)",
    fill: "#a77834"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.4ac94ace90b6c8e2316205170298788b.svg";
export { ForwardRef as ReactComponent };